export const OPEN_WIZARD = "OPEN_WIZARD";
export const CLOSE_WIZARD = "CLOSE_WIZARD";
